import {combineReducers} from 'redux';
import Definition from 'routes/Home/Attendance/Setting/Definition/Module';
import Assignment from 'routes/Home/Attendance/Setting/Assignment/Module';

const reducers = combineReducers({
  Definition,
  Assignment,
});

export default reducers;
